export default __webpack_public_path__ + "static/media/GRIDBUY.f5706155.svg";